import { render } from "./UserGroupsRenderer.vue?vue&type=template&id=79b6a75e&scoped=true"
const script = {}

import "./UserGroupsRenderer.vue?vue&type=style&index=0&id=79b6a75e&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b6a75e"]])

export default __exports__